import { render } from "./App.vue?vue&type=template&id=6554ce21"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6554ce21&lang=css"

import exportComponent from "/Users/admin/#_Projects/vegeta/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__